import React, { lazy, Suspense } from 'react';
import { IntlProvider } from 'react-intl';
import Spinner from 'react-bootstrap/Spinner';
import { HashRouter, Switch, Route, Redirect } from 'react-router-dom';
import { ToastProvider } from 'react-toast-notifications';
import { createBrowserHistory } from 'history';
import './assets/font-icons/style.css';
import './main.scss';
import tracker from './app/GA-Tracking';

const Login = lazy(() => import('./app/Login'));
const Signup = lazy(() => import('./app/Signup'));
const ForgotPassword = lazy(() => import('./app/ForgotPassword'));
const Terms = lazy(() => import('./app/Terms'));
const ResetPassword = lazy(() => import('./app/ResetPassword'));
const Confirmation = lazy(() => import('./app/Confirmation'));

// const location = window.location.pathname + window.location.search;
const history = createBrowserHistory();
history.listen(() => {
  tracker.setField(window.location.hash);
  tracker.sendPageView(window.location.hash);
});

/**
 * @function
 * @name App
 * @description Application Entry point
 *
 * @returns {object} React component
 *
 * @version 0.1.0
 * @since 0.1.0
 */
const App = () => {
  return (
    <IntlProvider>
      <ToastProvider placement="top-center">
        <HashRouter hashType="hashbang" history={history}>
          <Suspense
            fallback={
              <div className="d-flex align-items-center justify-content-center my-2">
                <Spinner
                  as="span"
                  animation="border"
                  role="status"
                  aria-hidden="false"
                />
              </div>
            }
          >
            <Switch>
              <Route exact path="/" component={Login} />
              <Route path="/register" component={Signup} />
              <Route path="/forgotpassword" component={ForgotPassword} />
              <Route path="/changepassword" component={ResetPassword} />
              <Route path="/terms" component={Terms} />
              <Route path="/confirmation" component={Confirmation} />
              <Route
                exact
                path="/confirmation?role=reseller"
                component={Confirmation}
              />
              <Redirect to="/" />
            </Switch>
          </Suspense>
        </HashRouter>
      </ToastProvider>
    </IntlProvider>
  );
};

export default App;
